import { useEffect, type ReactNode } from 'react';

// v2 adds the touch rule; a v1 element an older page already injected must not be reused.
const REVEAL_STYLE_ID = 'canvas-reveal-group-style-v2';

function ensureRevealStyle(): void {
  if (document.getElementById(REVEAL_STYLE_ID)) {
    return;
  }
  const style = document.createElement('style');
  style.id = REVEAL_STYLE_ID;
  // Shown while the pointer is anywhere over the affordance's block (DB-05 review I3), and on
  // keyboard focus — not only when the pointer finds the affordance's own invisible spot. A touch
  // screen has no hover, so there they stay visible (nothing else would ever reveal them).
  style.textContent = [
    '[data-quote-canvas-root]:hover [data-canvas-affordance="reveal"],',
    '[data-canvas-affordance="group"]:hover > [data-canvas-affordance="reveal"],',
    '[data-canvas-affordance="group"]:focus-within > [data-canvas-affordance="reveal"]{opacity:1 !important}',
    '@media (hover: none){[data-canvas-affordance="reveal"]{opacity:1 !important}}'
  ].join('');
  document.head.appendChild(style);
}

export function CanvasRevealGroup({ children }: { children: ReactNode }) {
  useEffect(() => {
    ensureRevealStyle();
  }, []);

  return (
    <div data-canvas-affordance="group" style={{ position: 'relative', height: 0 }}>
      <div data-canvas-affordance="reveal" style={{ position: 'absolute', top: 0, right: 0, opacity: 0 }}>
        {children}
      </div>
    </div>
  );
}
